import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, LOCALE_ID, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PagesService } from '@services/pages.service';
import { SharedService } from '@services/shared.service';
import { AuthService } from 'src/app/Auth/AuthService';
import { environment } from '@env';

@Component({
  selector: 'app-forgotpassword',
  standalone: true,
  imports: [RouterLink, ReactiveFormsModule, CommonModule, TranslateModule],
  templateUrl: './forgot.component.html',
  styleUrls: ['./forgot.component.scss', '../../../../auth.scss'],

})
export class ForgotComponent implements OnInit {
  baseUrl = environment.baseUrl;
  ForgetPasswordForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private route: Router,
    private authService: AuthService,
    private pageService: PagesService,
    private sharedService: SharedService
  ) {}

  ngOnInit(): void {
    this.ForgetPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
    const sessionId = new URLSearchParams(window.location.search).get(
      'session_id'
    );
    if (sessionId) {
      const data = {
        session_id: sessionId,
      };
      this.pageService.update('CHECK_PAYMENT', data).subscribe({
        next: (response: any) => {
          if (
            !response.data?.isSuccess &&
            response.data?.isSuccess !== undefined
          ) {
            return;
          }
          this.sharedService.createNotification(
            'success',
            response.data?.status
          );
        },
      });
    }
  }

  sendResetLink() {
    this.sharedService.showLoader();
    this.pageService
      .create('SEND_RESET_LINK', { email: this.ForgetPasswordForm.value.email })
      .subscribe({
        next: (response: any) => {
          this.sharedService.hideLoader();
          if (response.isSuccess) {
            this.sharedService.createNotification(
              'success',
              response.message || 'Reset link sent! Kindly check your inbox.'
            );

            const url = new URL(window.location.href);
            url.searchParams.delete('session_id');
            window.history.replaceState({}, '', url.toString());
            this.route.navigate(['/auth/reset-password']);
          } else {
            this.sharedService.createNotification(
              'error',
              response.message || 'Failed to send reset link.'
            );
          }
        },
        error: (err: any) => {
          this.sharedService.hideLoader();
          this.sharedService.createNotification(
            'error',
            err?.error?.message || err?.message || 'Failed to send reset link.'
          );
        },
      });
  }
}
